import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import reportWebVitals from "./reportWebVitals";
import { Amplify, Auth } from "aws-amplify";
import awsExports from "./aws-exports";
import "./features/i18n/i18n";
import "./index.css";
import { RouterProvider } from "react-router-dom";
import { router } from "./app/router";
import { getBaseEndpoint } from "./app/utils";
import { getClientMetadataHeaders } from "./lib/client-metadata";
import "./lib/api-interceptor";

const baseAPIEndpoint = getBaseEndpoint();

Amplify.configure({
  ...awsExports,
  storage: localStorage,
  API: {
    endpoints: [
      {
        name: "simpl-api",
        endpoint: baseAPIEndpoint,
        region: "us-east-1",
        custom_header: async () => {
          const clientHeaders = getClientMetadataHeaders();
          try {
            const session = await Auth.currentSession();
            const token = session.getIdToken().getJwtToken();
            return { ...clientHeaders, Authorization: `Bearer ${token}` };
          } catch (error) {
            // No authenticated session - return client headers only for unauthenticated endpoints
            // This allows endpoints like /invites/verify and /invites/complete to work
            return { ...clientHeaders };
          }
        }
      }
    ]
  }
});

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
